import { id } from "../common/statics";
const initialState = null;

export const SAVE_FILE = 'SAVE_FILE';

export const saveFile = (file) => {
    return {
        type: SAVE_FILE,
        payload: file,
    };
};

export const UPDATE_PROPERTY_FOR_ALL = 'UPDATE_PROPERTY_FOR_ALL';
export const UPDATE_PROPERTY_FOR_EMPTIES = 'UPDATE_PROPERTY_FOR_EMPTIES';

export const FILTER_IDS_TO_NUMBERS = 'FILTER_IDS_TO_NUMBERS';

export const updatePropertyForAll = (propertyName, newValue) => {
    return {
        type: UPDATE_PROPERTY_FOR_ALL,
        payload: { propertyName, newValue },
    };
};
export const updatePropertyForEmpties = (propertyName, newValue) => {
    return {
        type: UPDATE_PROPERTY_FOR_EMPTIES,
        payload: { propertyName, newValue },
    };
};
export const UPDATE_PROPERTY = 'UPDATE_PROPERTY';

export const updateProperty = (index, propertyName, newValue) => {
    return {
        type: UPDATE_PROPERTY,
        payload: { index, propertyName, newValue },
    };
};

export const fileReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_FILE:
            return action.payload;
        case UPDATE_PROPERTY:
            return state.map((item, i) =>
                i === action.payload.index
                    ? { ...item, [action.payload.propertyName]: action.payload.newValue }
                    : item
            );
        case UPDATE_PROPERTY_FOR_ALL:
            return state.map(item => ({
                ...item,
                [action.payload.propertyName]: action.payload.newValue
            }));
        case UPDATE_PROPERTY_FOR_EMPTIES:
            return state.map(item => {
                const isNotEmpty = item[action.payload.propertyName] === '' || item[action.payload.propertyName] === undefined || item[action.payload.propertyName] === null ? false : true;

                return {
                    ...item,
                    [action.payload.propertyName]: isNotEmpty ? item[action.payload.propertyName] : action.payload.newValue
                }
            });
        case FILTER_IDS_TO_NUMBERS:
            return state.map(item => ({
                ...item,
                [id]: String(item[id])?.replace(/\D/g, '')
            }));

        default:
            return state;
    };
};

